<template>
  <v-card text tile>
    <v-card-title class="text-h6 purple lighten-5">Cours suivis</v-card-title>
    <v-data-table
      style="width: 100%"
      class="mytable"
      hide-default-footer
      :headers="headers"
      :items="studentCourses"
      :no-data-text="'Aucun'"
      v-model="selected"
      item-key="id"
      :sort-by="['id']"
      :sort-desc="true"
      dense
    >
      <template v-slot:body="{ items }">
        <tbody>
          <tr v-for="item in items" :key="item.id" :active="item.id == activeCourseScId" @click="getTest(item.id)">
            <td>{{ item.course.type_full }}</td>
            <td>{{ item.course.name }}</td>
            <td>{{ item.level || UNDEFINED }}</td>
            <td>{{ item.course.start | dateToHuman }}</td>
            <td>{{ item.course.end | dateToHuman }}</td>
          </tr>
        </tbody>
      </template>
    </v-data-table>
  </v-card>
</template>
<script>
import StudentCourse from "@/models/StudentCourse"
import Course from "@/models/Course"
import Description from "@/models/Description"

export default {
  props: {
    student_id: {
      required: true,
      type: Number,
    },
  },
  data() {
    return {
      UNDEFINED: Description.UNDEFINED,
      headers: [
        { text: "Type", value: "full_type" },
        { text: "Nom du cours", value: "course.name", sortable: true },
        { text: "Niveau", value: "sc.level", sortable: true },
        {
          text: "Début",
          value: "course_start",
          sortable: true,
        },
        { text: "Fin", value: "course_end", sortable: true },
      ],
      edit: false,
      selected: [],
      activeCourseScId: null,
    }
  },
  mounted() {
    this.getDataFromApi()
  },
  computed: {
    studentCourses() {
      let scs = StudentCourse.query().where("student_id", this.student_id).with("course").get()
      if (scs.length) {
        this.activeCourseScId ??= scs[scs.length - 1]["id"]
      }
      return scs
    },
  },
  methods: {
    getTest(val) {
      val ? (this.activeCourseScId = val) : ""
      this.$parent.$emit("activeCourseEvent", this.activeCourseScId)
    },
    async getDataFromApi() {
      this.loading = true
      await Course.get()
      await StudentCourse.getStudentCoursesByStudentId(this.student_id)
      this.loading = false
      this.getTest(this.studentCourses?.[this.studentCourses.length - 1]?.student_course_id)
    },
    selectCourse(value) {
      if (this.selected.length) this.selected = []
      else this.selected = value
    },
  },
}
</script>
<style scoped>
.mytable {
  cursor: pointer;
  border-radius: none !important;
}
tbody tr[active] {
  background-color: #81c784;
}

div.v-application {
  display: block;
}
div.v-application.th {
  white-space: nowrap;
}
div.v-content__wrap {
  width: 100%;
}
</style>
>
